import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const CLU_TICKENTETE_SCHEMA_LITERAL = {
    title: 'Schéma EnteteTicket',
    description: 'Ticket',
    version: 20,
    keyCompression: false,
    primaryKey: 'DO_PIECE_INTERNAL',
    type: 'object',
    properties: {
        MD_DOGID : { type : 'string' },
        MD_SITEGID : { type : 'string' },
        MD_SITE : { type : 'string' },
        MD_CAISSE : { type : 'string' },
        MD_CAISSE_LIB : { type : 'string' },
        MD_CAISSIERGID : { type : 'string' },
        MD_CAISSIER : { type : 'string' },
        MD_CAISSIER_LIB : { type : 'string' },
        MD_CAISSE_SESSION : { type : 'string' },
        MD_LOCALGID : { type : 'string' },
        MD_DATE_CREATION : { type : 'string' },
        MD_CBMARQ : { type : 'number' },
        DO_PIECE : { type : 'string' },
        DO_PIECE_INTERNAL : { type : 'string', maxLength: 100 },
        DO_DATE : { type : 'string' },
        DE_NO: { type: 'number' },
        DE_INTITULE: { type: 'string' },
        DO_SOUCHE: { type: 'number' },
        DO_SOUCHELIB: { type: ['string', 'null'] },
        CA_NUM: { type: ['string', 'null'] },
        CA_INTITULE: { type: ['string', 'null'] },
        CO_NO : { type : 'number' },
        CO_LIB : { type : ['string', 'null'] },
        DO_DEVISE : { type : 'number', default : 0 },
        DO_DEVISELIB : { type : 'string' },
        DO_DEVISE_FORMAT : { type : 'string' },
        DO_DEVISE_INV : { type : 'number', default : 0 },
        DO_COURS : { type : 'number', default : 0 },
        DO_REF : { type : 'string', default : '' },
        DO_COORD02 : { type : 'string', default : '' },
        DO_COORD03 : { type : 'string', default : '' },
        DO_COORD04 : { type : 'string', default : '' },
        DO_TIERS : { type : 'string' },
        CT_INTITULE : { type : 'string' },
        CT_TAUX01 : { type : 'number' },
        DO_REM_CONFLICT_MODE : { type : 'number' },
        DO_TOTALHT: { type: 'number', default : 0 },
        DO_TOTALHTNET: { type: 'number', default : 0 },
        DO_TOTALTTC : { type : 'number', default : 0 },
        DO_NETAPAYER: { type: 'number', default : 0 },
        DO_SOLDETTC: { type: 'number', default : 0 },
        DO_MONTANTREGLE: { type: 'number', default : 0 },
        DO_TAXES : { type : ['number', 'null'] }, 
        LC_CARTE_NUM  : { type : 'string' }, 
        DO_PRINT_NB  : { type : 'number' }, 
        DO_PRINT_AT  : { type : ['string', 'null'] }, 
        DO_PRINT_LAST  : { type : ['string', 'null'] }, 
        DO_EMAIL_NB  : { type : 'number' }, 
        DO_EMAIL_AT  : { type : ['string', 'null'] }, 
        DO_EMAIL_LAST  : { type : ['string', 'null'] }, 
        DO_EMAIL_1  : { type : ['string', 'null'] }, 
        DO_EMAIL_2  : { type : ['string', 'null'] }, 
        DO_EMAIL_3  : { type : ['string', 'null'] }, 
        CL_EXTRAS  : { type : ['string', 'null'] }, 
        ZSYNCUP_FLAG  : { type : 'number', default : 0 },
        ZSYNCUP_STATUS  : { type : 'string' },
        ZSYNCUP_ERROR_MESSAGE  : { type : 'string' },
        ZSYNCUP_DATETIME  : { type : 'string' },
        ZSYNCUP_FEEDID  : { type : 'string' },
        ZTICKET_STATUS : { type : 'number', default : 0 },
        ZSTORAGE_MODE : { type : 'number', default : 0 }, 

        DO_DATE_UTC  : { type : ['string', 'null'] }, 
        DO_TYPE_OP  : { type : ['string', 'null'] }, 
        DO_NB_LIGNES  : { type : ['number', 'null'] }, 
        CLU_APP_VERSION  : { type : ['string', 'null'] }, 
        DO_PIECE_INTERNAL_PREVIOUS  : { type : ['string', 'null'] }, 
        DO_SIGNATURE_OFFLINE  : { type : ['number', 'null'] }, 
        DO_SIGNATURE_DATETIME  : { type : ['string', 'null'] }, 
        DO_SIGNATURE_REPORT  : { type : ['number', 'null'] }, 
        DO_SIGNATURE  : { type : ['string', 'null'] }, 
        DO_SIGNATURE_PREVIOUS  : { type : ['string', 'null'] }, 
        DO_SIGNATURE_DATA  : { type : ['string', 'null'] }, 
        DO_TAXE_ITEMS_JSON  : { type : ['string', 'null'] },
        
        DO_DATEDEBUT  : { type : ['string', 'null'] }, 
        DO_DATEFIN  : { type : ['string', 'null'] }, 
        DO_REMISE_MT  : { type : ['number', 'null'] }, 
        DO_RG_ESP_RECU_TOT  : { type : ['number', 'null'] }, 
        DO_RG_ESP_RENDU_TOT  : { type : ['number', 'null'] }, 
        DO_RG_MONTANTECART  : { type : ['number', 'null'] }, 
        DO_MONTANTREGLE_F  : { type : ['number', 'null'] },
        DO_MOREPARAMS_JSON  : { type : ['string', 'null'] },
        DO_TOT_QTE  : { type : ['number', 'null'] },
        DO_TOTALTTC_P  : { type : ['number', 'null'] },

        ZSYNCAGENTUP_FLAG  : { type : 'number', default : 0 },
        ZSYNCAGENTUP_STATUS  : { type : 'string' },
        ZSYNCAGENTUP_ERROR_MESSAGE  : { type : 'string' },
        ZSYNCAGENTUP_DATETIME  : { type : 'string' },
        ZSYNCAGENTUP_FEEDID  : { type : 'string' }, 
    },
    required: [ 'DO_PIECE_INTERNAL', 'DO_PIECE', 'DO_DATE', 'DO_TIERS', 'CT_INTITULE', 'DO_TOTALHT', 'DO_TOTALTTC', 'DO_NETAPAYER', 'DO_SOLDETTC', 'DO_MONTANTREGLE' ]
} as const;

const schemaTyped = toTypedRxJsonSchema(CLU_TICKENTETE_SCHEMA_LITERAL);
export type RxCluTickEnteteDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const CLU_TICKENTETE_SCHEMA: RxJsonSchema<RxCluTickEnteteDocumentType> = CLU_TICKENTETE_SCHEMA_LITERAL;
